export default __webpack_public_path__ + "staticFile/media/close.9be93b2f.svg";